import { Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { PublicComponent } from './layouts/public/public.component';
import { authGuard } from './shared/guards/auth.guard';
import { ProfileComponent } from './pages/profile/profile.component';
import { DashboardComponent } from './pages/school/dashboard/dashboard.component';
import { PERMISSIONS } from './config/permissions.constant';
import { RENTALS_PERMISSIONS } from './config/rentals.permissions';
import { EnrollComponent } from './pages/enroll/enroll.component';
import { PortalAccessRequestComponent } from './pages/portal-access-request/portal-access-request.component';
import { PortalAccessComponent } from './pages/portal-access/portal-access.component';

export const routes: Routes = [
  {
    path: 'public',
    component: PublicComponent,
    children: [
      {
        path: 'students',
        loadChildren: () =>
          import('./pages/student/student.routes').then((m) => m.studentRoutes),
      },
    ],
  },
  {
    path: 'enroll/:schoolId',
    component: BlankComponent,
    children: [
      {
        path: '',
        component: EnrollComponent,
      },
    ],
  },
  {
    // Public page: student enters email to receive a 10-minute access link
    path: 'portal-access-request',
    component: BlankComponent,
    children: [
      {
        path: '',
        component: PortalAccessRequestComponent,
      },
    ],
  },
  {
    // Student lands here after clicking the link in their email
    path: 'portal-access/:token',
    component: BlankComponent,
    children: [
      {
        path: '',
        component: PortalAccessComponent,
      },
    ],
  },
  {
    path: 'auth',
    component: BlankComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/auth/auth.routes').then((m) => m.AuthRoutes),
      },
    ],
  },
  {
    path: '',
    component: FullComponent,
    canActivate: [authGuard],
    data: {
      perm: [PERMISSIONS.PUBLIC],
    },
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'profile/:userId',
        component: ProfileComponent,
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [authGuard],
        data: { perm: [PERMISSIONS.DASHBOARD] },
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./pages/settings/settings.routing').then(
            (m) => m.SettingsRoutes,
          ),
        canActivateChild: [authGuard],
        data: {
          perm: [
            PERMISSIONS.ADMIN,
            PERMISSIONS.ACTIVITIES,
            PERMISSIONS.SCHOOL_MODALITIES,
            PERMISSIONS.SCHOOL_LEVELS,
            PERMISSIONS.SCHOOL_PRODUCTS,
            PERMISSIONS.SCHOOL_MEMBERS,
          ],
        },
      },
      {
        path: 'school',
        loadChildren: () =>
          import('./pages/school/school.routes').then(
            (m) => m.FrontDeskManagerRoutes,
          ),
        canActivateChild: [authGuard],
        data: {
          perm: [
            PERMISSIONS.SCHOOL_LESSONS,
            PERMISSIONS.SCHOOL_BOOKINGS,
            PERMISSIONS.SCHOOL_STUDENTS,
            PERMISSIONS.SCHOOL_FINANCE,
            PERMISSIONS.SCHOOL_STUDENT_EXCHANGE,
            PERMISSIONS.INSTRUCTOR_LESSONS,
            PERMISSIONS.SCHOOL_PROFILE,
          ],
        },
      },
      {
        path: 'instructor',
        loadChildren: () =>
          import('./pages/instructor/instructor.routes').then((r) => r.routes),
        canActivateChild: [authGuard],
        data: {
          perm: [PERMISSIONS.INSTRUCTOR, PERMISSIONS.INSTRUCTOR_LESSONS],
        },
      },
      {
        path: 'rentals',
        loadChildren: () =>
          import('./pages/rentals/rentals.routes').then(
            (m) => m.RENTALS_ROUTES,
          ),
        canActivateChild: [authGuard],
        data: { perm: [...RENTALS_PERMISSIONS.VIEW_MODULE] },
      },
      {
        path: 'boxes',
        loadChildren: () =>
          import('./pages/boxes/boxes.routes').then((m) => m.BOXES_ROUTES),
        canActivateChild: [authGuard],
        data: { perm: [PERMISSIONS.SCHOOL_BOXES] },
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];
